import styled from 'styled-components';

export default styled.kbd`
  ${p => p.theme.type.textSmall}
  font-size: 12px;
  line-height: 16px;
  color: var(--mms-simple-foreground, ${p => p.theme.generic.dark.foreground});
  opacity: 0.9;
`;
